const callpark = (state = [], action) => {
    switch (action.type) {
      case 'CALLPARK':
        return action.callpark
      default:
        return state
    }
  }
  
  export default callpark